var $ = require('jquery');

export class CustomFileInput{
  private $el;
  private $customInput;
  private $customPlaceholder;
  private block;

  constructor(private element: HTMLElement, private selectClass) {
    this.block = selectClass;
    this.$el = $(element);
    this.$customInput = this.$el.find('.' + this.block + '__input');
    this.$customPlaceholder = this.$el.find('.' + this.block + '__placeholder');
  }

  private _onFileSelection(value) {
    //set filename as input placeholder
    const fileName = value ? value.split('\\').pop().split('/').pop() : ''; //returns string after / or \
    this.$customPlaceholder.text(fileName);
  }

  private _attachListeners()  {
    this.$customInput.on('change', (e) => {
      this._onFileSelection(e.target.value);
    });
  }

  public init() {
    if(!this.$el.length) {
      return;
    }
    this._attachListeners();
  }

}
